import html2pdf from 'html2pdf.js';

/**
 * Converts a DOM ref to a downloadable PDF.
 * @param {React.RefObject} contentRef  - ref pointing to the element to capture
 * @param {object}          [opts]      - optional overrides
 * @param {'portrait'|'landscape'} [opts.orientation] - PDF page orientation (default: 'portrait')
 * @param {string}          [opts.filename]            - output file name (default: 'report.pdf')
 */
export const convertToPdf = async (contentRef, opts = {}) => {
    const content = contentRef.current;
    const { orientation = 'portrait', filename = 'report.pdf' } = opts;

    const options = {
        filename,
        margin: [0.3, 0.2],          // top/bottom, left/right margins in inches
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, allowTaint: true },
        jsPDF: {
            unit: 'in',
            format: 'letter',
            orientation,
        },
        pagebreak: { mode: ['css', 'legacy'] }
    };
    await html2pdf().set(options).from(content).save();
};
